import { Fragment } from "react";
import { Grid } from "@mui/material";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import type { IToken } from "@framework/types";
import { useFetchData } from "@dzambalaorg/react-hooks";

import { CommonTokenPanel, TokenHistory } from "../../../../../components/common";
import { MysteryTokenPanel } from "./mystery-token-panel";
import { StyledDescription, StyledImage } from "./styled";

export const MysteryBoxToken = () => {
  const { data, isLoading, refetch } = useFetchData<IToken>("/mystery/tokens");

  if (isLoading) {
    return <Spinner />;
  }

  if (!data) {
    // TODO - [AFTER ALL REFACTORING] - add universal no data component
    return <div>No data</div>;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "mystery", "mystery.token"]} data={[{}, {}, data.template]} />

      <PageHeader message="pages.mystery.token.title" data={data.template} />

      <Grid container>
        <Grid size={{ xs: 12, sm: 9 }}>
          <StyledImage component="img" src={data.template!.imageUrl} alt="Cascadify token image" />
          <StyledDescription>
            <RichTextDisplay data={data.template!.description} />
          </StyledDescription>
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          {data.templateId ? (
            <>
              <CommonTokenPanel token={data} />
              <MysteryTokenPanel token={data} onRefreshPage={refetch} />
            </>
          ) : null}
        </Grid>
      </Grid>

      {data.id ? <TokenHistory token={data} /> : null}
    </Fragment>
  );
};
